import React, { ChangeEvent, FormEvent, useContext, useState } from 'react'
import { Box, Button, Checkbox, Field, Input, Text, VStack } from '@chakra-ui/react'
import { SessionIdContext } from '../../auth/user-context'
import { useNotification } from '../components/notifications'

export const SoftwareUpload = () => {
    const setNotification = useNotification()

    const [file, setFile] = useState<File | null>(null)
    const [uploading, setUploading] = useState(false)
    const [addToDev, setAddToDev] = useState(true)

    const sessionId = useContext(SessionIdContext)

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setFile(e.target.files[0])
        }
    }

    const handleUpload = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        try {
            if (!file) {
                throw new Error('Select a file first')
            }

            const formData = new FormData()
            formData.append('file', file)
            formData.append('devChannel', addToDev ? 'true' : 'false')

            setUploading(true)

            const response = await fetch('/api/upload', {
                method: 'POST',
                body: formData,
                headers: {
                    'session-id': sessionId
                }
            })

            if (!response.ok) {
                throw new Error('Network response was not ok')
            }

            const result = (await response.json()) as any
            setNotification({
                type: result.status ? 'info' : 'error',
                message: result.message
            })
        } catch (error: any) {
            setNotification({
                type: 'error',
                message: `${error}`
            })
        } finally {
            setUploading(false)
        }
    }

    return (
        <Box>
            <form onSubmit={handleUpload}>
                <VStack align="stretch" gap={4}>
                    <Field.Root>
                        <Field.Label>Select a probe software binary to upload</Field.Label>
                        <Input type="file" onChange={handleFileChange} p={1} />
                        {file && (
                            <Text fontSize="sm" color="gray.400">
                                Selected: {file.name}
                            </Text>
                        )}
                    </Field.Root>

                    <Field.Root>
                        <Checkbox.Root
                            checked={addToDev}
                            onCheckedChange={(details) => setAddToDev(!!details.checked)}
                        >
                            <Checkbox.HiddenInput />
                            <Checkbox.Control />
                            <Checkbox.Label>Add to dev channel</Checkbox.Label>
                        </Checkbox.Root>
                    </Field.Root>

                    <Button colorPalette="blue" type="submit" disabled={uploading}>
                        {uploading ? 'Uploading...' : 'Upload'}
                    </Button>
                </VStack>
            </form>
        </Box>
    )
}
